export default {"src":"/_next/static/media/generic-thumbnail-weblink.481cd385.svg","height":83,"width":62,"blurWidth":0,"blurHeight":0};